import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import pageNo from '../pages'
import pageRouters from './pageRouters'
import store from '../store'
import ElementUI from 'element-ui'

Vue.use(Router)
/* 加载进度 */
NProgress.configure({
  speed: 500,
  showSpinner: false
})
const routes = [
  {
    path: '/',
    component: pageNo,
    children: [
      ...pageRouters
    ]
  }
]

const router = new Router({
  routes: routes
})

// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
   if (localStorage.getItem('token')) { // 判断当前的token是否存在； 登录存入的token
    // 实时更新 路由、操作项
    next()
   }
   else {
    next({
     path: '/login',
     query: {redirect: to.fullPath} //将跳转的路由path作为参数，登录成功后跳转到该路由
    })
   }
  }
  else {
   next();
  }
});
 
// 进度条
router.afterEach(() => {
  NProgress.done()
})

// 解决路由重复单击报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err)=>err)
}

export default router
